import { DotFlashing, FieldLabel, FlexRowDiv, HeaderDiv } from "../../styledComponents/Components.styles";
import palette from "../../../utilities/palette";

export default function VBFTypeLabelField ({
    label,
    value,
    cursor,
    errorMessage = "",
    isLoading = false,
}: Readonly<{
    label: string,
    value: string,
    cursor?: string,
    errorMessage?: string,
    isLoading?: boolean,
}>) {
    return (
        <HeaderDiv style={{display: 'flex', flexDirection: 'column', gap: errorMessage ? '12px': '16px' }}>
            <FieldLabel variant="body" style={{cursor: cursor ? "pointer" : "default" }} >
                {label}
            </FieldLabel>

            {isLoading ? 
            <FlexRowDiv style={{gap: '10px', alignItems: 'center'}}>
                <span style={{color: palette.main, fontSize: 18, fontWeight: 400}}>Processing</span>
                <DotFlashing size="medium" />
            </FlexRowDiv>
            :
            <label style={{fontSize: errorMessage ? 16 : 18, fontWeight: 500, color: errorMessage ? palette.stepper.error : "black", cursor: cursor ? "pointer" : "grey" }} >
                {errorMessage ? errorMessage : value}
            </label>
        }
            
            
        </HeaderDiv>
    )
}